import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore/lite";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Firebase 웹 설정은 공개 식별자다. 번들에 그대로 실려 나가는 값이고, 숨길 수 없다.
// 실제 보호는 Firestore 규칙(infra/firestore.rules)과 서버 권위가 한다.
// 비밀은 GEMINI_API_KEY 뿐이고 그건 Secret Manager 에만 있다.
const config = {
  apiKey: "AIzaSyAZ2ztAfochW880bBh4-IJi-baERe5tGkM",
  authDomain: "sowhat-run.firebaseapp.com",
  projectId: "sowhat-run",
  storageBucket: "sowhat-run.firebasestorage.app",
  messagingSenderId: "627567526831",
  appId: "1:627567526831:web:ddf8483541d016524c655a",
};

// reCAPTCHA Enterprise 사이트 키. 페이지에 실려 나가는 공개 식별자다.
const RECAPTCHA_SITE_KEY = "6LeOp8ctAAAAAMdivmeAB3udscUurC5ExEojZgyx";

export const app = initializeApp(config);

/**
 * App Check — 스크립트 남용을 막는 겹.
 *
 * 하루 한 번(USER_DAILY_LIMIT)은 익명 uid 기준이라 시크릿 창으로 우회된다.
 * 즉 개인 한도는 약속이지 방어선이 아니다. 실제로 지갑을 지키는 건
 * GLOBAL_DAILY_LIMIT 과 이것이다 — 자동화로 익명 세션을 돌려 정원을
 * 태우는 것을 막는다.
 *
 * 개발 중에는 디버그 토큰을 쓴다. 콘솔에 찍히는 토큰을 Firebase 콘솔의
 * App Check → 앱 → 디버그 토큰에 등록해야 에뮬레이터에서도 통과한다.
 */
if (import.meta.env.DEV) {
  globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
// 비밀번호 재설정 메일 등 Firebase 가 보내는 메일의 언어.
auth.languageCode = "ko";
export const db = getFirestore(app);

// 함수는 Firestore 와 같은 리전에 있다. 리전을 빼면 us-central1 로 찾아가서 404 가 난다.
const fns = getFunctions(app, "asia-northeast3");

// 에뮬레이터는 개발 중에만. infra/ 에서 띄운 포트와 맞춰야 한다.
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATOR !== "false") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8081);
  connectFunctionsEmulator(fns, "127.0.0.1", 5001);
}

/** 게이트웨이와 화면이 함수를 부르는 유일한 통로. */
export const callFunction = (name, data) =>
  httpsCallable(fns, name)(data).then((r) => r.data);
